import LanguageToken from '@admin/tokens/langauge'
import Select from '@admin/components/form/select'
import PropTypes from 'prop-types'
import React from 'react'

const LangaugeField = React.forwardRef((props, ref) => {

  const multiple = props.multiple === true
  const defaultValue = props.defaultValue || 'albanian'

  const mergeProps = {
    columns: 5,
    options: [
      { text: 't(Albanian)', value: 'albanian', countryCode: 'AL' },
      { text: 't(Amharic)', value: 'amharic', countryCode: 'AM' },
      { text: 't(Arabic)', value: 'arabic', countryCode: 'AR' },
      { text: 't(Armenian)', value: 'armenian', countryCode: 'AM' },
      { text: 't(Bengali)', value: 'bengali', countryCode: 'BD' },
      { text: 't(Bosnian)', value: 'bosnian', countryCode: 'BA' },
      { text: 't(Bulgarian)', value: 'bulgarian', countryCode: 'BG' },
      { text: 't(Burmese)', value: 'burmese', countryCode: 'MM' },
      { text: 't(Catalan)', value: 'catalan', countryCode: 'ES' },
      { text: 't(Chinese)', value: 'chinese', countryCode: 'CN' },
      { text: 't(Croatian)', value: 'croatian', countryCode: 'HR' },
      { text: 't(Czech)', value: 'czech', countryCode: 'CZ' },
      { text: 't(Danish)', value: 'danish', countryCode: 'DK' },
      { text: 't(Dutch)', value: 'dutch', countryCode: 'NL' },
      { text: 't(English)', value: 'english', countryCode: 'US' },
      { text: 't(Estonian)', value: 'estonian', countryCode: 'EE' },
      { text: 't(Finnish)', value: 'finnish', countryCode: 'FI' },
      { text: 't(French)', value: 'french', countryCode: 'FR' },
      { text: 't(Georgian)', value: 'georgian', countryCode: 'GE' },
      { text: 't(German)', value: 'german', countryCode: 'DE' },
      { text: 't(Greek)', value: 'greek', countryCode: 'GR' },
      { text: 't(Gujarati)', value: 'gujarati', countryCode: 'IN' },
      { text: 't(Hindi)', value: 'hindi', countryCode: 'IN' },
      { text: 't(Hungarian)', value: 'hungarian', countryCode: 'HU' },
      { text: 't(Icelandic)', value: 'icelandic', countryCode: 'IS' },
      { text: 't(Indonesian)', value: 'indonesian', countryCode: 'ID' },
      { text: 't(Italian)', value: 'italian', countryCode: 'IT' },
      { text: 't(Japanese)', value: 'japanese', countryCode: 'JP' },
      { text: 't(Kannada)', value: 'kannada', countryCode: 'IN' },
      { text: 't(Kazakh)', value: 'kazakh', countryCode: 'KZ' },
      { text: 't(Korean)', value: 'korean', countryCode: 'KR' },
      { text: 't(Latvian)', value: 'latvian', countryCode: 'LV' },
      { text: 't(Lithuanian)', value: 'lithuanian', countryCode: 'LT' },
      { text: 't(Macedonian)', value: 'macedonian', countryCode: 'MK' },
      { text: 't(Malay)', value: 'malay', countryCode: 'MY' },
      { text: 't(Malayalam)', value: 'malayalam', countryCode: 'IN' },
      { text: 't(Marathi)', value: 'marathi', countryCode: 'IN' },
      { text: 't(Mongolian)', value: 'mongolian', countryCode: 'MN' },
      { text: 't(Norwegian)', value: 'norwegian', countryCode: 'NO' },
      { text: 't(Persian)', value: 'persian', countryCode: 'IR' },
      { text: 't(Polish)', value: 'polish', countryCode: 'PL' },
      { text: 't(Portuguese)', value: 'portuguese', countryCode: 'PT' },
      { text: 't(Punjabi)', value: 'punjabi', countryCode: 'IN' },
      { text: 't(Romanian)', value: 'romanian', countryCode: 'RO' },
      { text: 't(Russian)', value: 'russian', countryCode: 'RU' },
      { text: 't(Serbian)', value: 'serbian', countryCode: 'RS' },
      { text: 't(Slovak)', value: 'slovak', countryCode: 'SK' },
      { text: 't(Slovenian)', value: 'slovenian', countryCode: 'SI' },
      { text: 't(Somali)', value: 'somali', countryCode: 'SO' },
      { text: 't(Spanish)', value: 'spanish', countryCode: 'ES' },
      { text: 't(Swahili)', value: 'swahili', countryCode: 'KE' },
      { text: 't(Swedish)', value: 'swedish', countryCode: 'SE' },
      { text: 't(Tagalog)', value: 'tagalog', countryCode: 'PH' },
      { text: 't(Tamil)', value: 'tamil', countryCode: 'IN' },
      { text: 't(Telugu)', value: 'telugu', countryCode: 'IN' },
      { text: 't(Thai)', value: 'thai', countryCode: 'TH' },
      { text: 't(Turkish)', value: 'turkish', countryCode: 'TR' },
      { text: 't(Ukrainian)', value: 'ukrainian', countryCode: 'UA' },
      { text: 't(Urdu)', value: 'urdu', countryCode: 'PK' },
      { text: 't(Vietnamese)', value: 'vietnamese', countryCode: 'VN' }
    ],
    format: LanguageToken
  }
  return <Select { ...mergeProps } { ...props } ref={ ref } defaultValue={ defaultValue } multiple={ multiple } selectFirst={ props.selectFirst !== false } />
})

LangaugeField.propTypes = {
  defaultValue: PropTypes.string,
  multiple: PropTypes.bool,
  selectFirst: PropTypes.bool
}

export default LangaugeField